module.exports = __webpack_public_path__ + "img/SER-A-2-II.3e2f1acc.png";